export const applyScopedClasses = (html, styles) => {
  return html.replace(/class="([^"]+)"/g, (match, classNames) => {
    const scopedClasses = classNames
      .split(' ')
      .map((className) => styles[className] || className)
      .join(' ');
    return `class="${scopedClasses}"`;
  });
};
